// dashboard
import Login from "pages/Authentication/Login";
import Logout from "pages/Authentication/LogOut";
import Register from "pages/Authentication/Register";
import UserProfile from "pages/Authentication/UserProfile";
import Ecommerce from "pages/Dashboards";
import AutoDraw from "pages/draw/AutoDraw";
import Four0Four from "pages/Four0Four";
import GameCategory from "pages/GameCategory";
import Games from "pages/games/Games";
import CreateGame from "pages/games/CreateGame";
import ViewGame from "pages/games/ViewGame";
import EditGame from "pages/games/EditGame";
import GameSlots from "pages/gameSlot/GameSlots";
import Players from "pages/player/Players";
import Tickets from "pages/ticket/Tickets";
import Transactions from "pages/Transaction/Transactions";
import WithdrawMethod from "pages/Transaction/WithdrawMethod";
import Trivia from "pages/Trivia/Trivia";
import QuestionSet from "pages/Trivia/QuestionSet";
import Winners from "pages/winners/Winners";
import QuestionsPerSet from "pages/Trivia/QuestionsPerSet";
import WinnerPerGameSlot from "pages/gameSlot/WinnerPerGameSlot";
import TicketsPerGameSlot from "pages/gameSlot/ticketsPerGameSlot";
import DetailsPerGameSlot from "pages/gameSlot/detailsPerGameSlot";
import EditGameSlot from "pages/gameSlot/EditGameSlot";
import MerchantBusiness from "pages/MerchantBusiness/MerchantBusiness";
import MerchantRewardEngine from "pages/MerchantRewardEngine/MerchantRewardEngine";
import MerchantApi from "pages/MerchantApi/MerchantApi";

interface RouteObject {
  path: string;
  component: React.ComponentType<any>; // Use React.ComponentType to specify the type of the component
  exact?: boolean;
}

const authProtectedRoutes: Array<RouteObject> = [
  // Dashboard
  { path: "/", component: Ecommerce },
  { path: "/dashboard", component: Ecommerce },
  { path: "/players", component: Players },
  { path: "/games", component: Games },
  { path: "/games/create", component: CreateGame },
  { path: "/games/view/:gameId", component: ViewGame },
  { path: "/games/edit/:gameId", component: EditGame },
  { path: "/game-slots", component: GameSlots },
  { path: "/game-slots/details/:gameSlotId", component: DetailsPerGameSlot },
  { path: "/game-slots/edit/:gameSlotId", component: EditGameSlot },
  { path: "/game-slots/tickets/:gameSlotId", component: TicketsPerGameSlot },
  { path: "/game-slots/winners/:gameSlotId", component: WinnerPerGameSlot },
  { path: "/game-categories", component: GameCategory },
  { path: "/auto-draw", component: AutoDraw },
  { path: "/tickets", component: Tickets },
  { path: "/winners", component: Winners },
  { path: "/questions-set", component: QuestionSet },
  { path: "/questions-set/:id", component: QuestionsPerSet },
  { path: "/transactions", component: Transactions },
  { path: "/withdraw-method", component: WithdrawMethod },
  { path: "/trivia", component: Trivia },
  { path: "/merchant-business", component: MerchantBusiness },
  { path: "/merchant-reward-engine", component: MerchantRewardEngine },
  { path: "/merchant-api", component: MerchantApi },

  // profile
  { path: "/user-profile", component: UserProfile },
];

const publicRoutes = [
  // authentication
  { path: "/login", component: Login },
  { path: "/logout", component: Logout },
  { path: "/register", component: Register },
  { path: "*", component: Four0Four },
];

export { authProtectedRoutes, publicRoutes };
